import React, { useState, useEffect } from "react";
import { Accordion, AccordionSummary, Box, Button, AccordionDetails, Typography } from "@mui/material";
import { getProductVariant } from "utilities";
import {
  fetchOverview,
  fetchAddress,
  fetchFunding,
  fetchRevenue,
  deleteRevenue,
  fetchInvestment,
  deleteInvestment,
  fetchVideo,
  deleteVideo,
  deleteCompanyDocument,
  fetchCompanyDocumentsByCompanyId,
  fetchCompanyDocumentUrl,
  deleteAddress,
  deleteFunding,
  fetchCompanyLogoUrl,
} from "middleware/services/companyApi";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { showLoader, hideLoader, actionError, actionSuccess } from "../../../../../middleware/actions/utilityAction";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import ThreeDotMenu from "../../../../components/threeDotMenu";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { showAlertBox } from "middleware/actions/alertBoxAction";
import ActionButtons from "./actionButtons";
import { setBasicDetailsCompany } from "middleware/actions/companyAction";
import { PRODUCT_VARIANT } from "constants";

const productVariant = getProductVariant();

const BasicUI = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const split_url = location.pathname.split("/");
  split_url.pop();

  const companyId = props.companyId || "";
  const [companyInformation, setCompanyInformation] = useState({
    pVariant: productVariant,
    companyName: "",
    companyFoundedYear: "",
    companyEmpSize: "",
    companyWebsite: "",
    companyPublishedDate: "",
    companyLogo: "",
  });
  const [locations, setLocations] = useState([]);
  const [fundings, setFundings] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [investments, setInvestments] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [documentListing, setDocumentListing] = useState([]);

  const [expandedAccordions, setExpandedAccordions] = useState({
    overview: false,
    address: false,
    fundings: false,
    revenue: false,
    investments: false,
    images: false,
    videos: false,
    documents: false,
  });

  const handleAccordionChange = (panel) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [panel]: !expandedAccordions[panel],
    }));
  };

  const fetchOverviewData = async () => {
    dispatch(showLoader());
    const response = await fetchOverview(companyId);
    if (response) {
      const val = response.data.data;

      setCompanyInformation({
        pVariant: productVariant,
        companyName: val.companyName,
        companyFoundedYear: val.companyFoundedYear || "-",
        companyEmpSize: val.companyEmpSize || "",
        companyWebsite: val.companyWebsite || "",
        companyPublishedDate:
          val.productVariant.find((item) => item.productName === productVariant || item.productName === PRODUCT_VARIANT.INSIDER)?.lastPublishedDate ||
          new Date(),
        companyLogo: val?.companyLogo || "",
      });
    }
    dispatch(hideLoader());
  };

  const handleFetchAddress = async () => {
    const response = await fetchAddress(companyId);
    response?.data && setLocations(response.data.data);
  };

  // delete a address handler
  const handleDeleteAddress = async (addressId) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteAddress(companyId, addressId)
            .then(() => {
              dispatch(actionSuccess("Address deleted successfully"));
            })
            .catch((err) => {
              dispatch(actionError(err?.data?.message || "Something went wrong"));
            });
          await handleFetchAddress();
        },
        okText: "Delete",
        cancelText: "Cancel",
        content: "Are you sure you want to Delete Address?",
        title: "dialogAlertCssWarning",
      })
    );
  };

  const handleFetchFunding = async () => {
    const response = await fetchFunding(companyId);
    if (response?.data?.data) {
      let data = response.data.data.map((item) => {
        return {
          ...item,
          fundingDate: item.fundingDate ? moment(item.fundingDate).format("DD-MMM-yyyy") : "",
        };
      });
      setFundings(data);
    }
  };

  // delete a funding
  const handleDeleteFunding = async (fundingId) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteFunding(fundingId);
          dispatch(actionSuccess("Funding deleted successfully"));
          await handleFetchFunding();
        },
        okText: "Delete",
        cancelText: "Cancel",
        content: "Are you sure you want to Delete Funding?",
        title: "dialogAlertCssWarning",
      })
    );
  };

  const handleFetchRevenue = async () => {
    const response = await fetchRevenue(companyId, { sort: "revenueYear:asc" });
    if (response?.data?.data) {
      let data = response?.data?.data?.companyRevenue?.map((item) => {
        return {
          ...item,
        };
      });
      setRevenue(data);
    }
  };

  const handleDeleteRevenue = async (revenueId) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteRevenue(companyId, revenueId);
          dispatch(actionSuccess("Revenue deleted successfully"));
          await handleFetchRevenue();
        },
        okText: "Delete",
        cancelText: "Cancel",
        content: "Are you sure you want to Delete Revenue?",
        title: "dialogAlertCssWarning",
      })
    );
  };

  const handleFetchInvestments = async () => {
    const response = await fetchInvestment(companyId);
    if (response?.data?.data) {
      let data = response.data.data.map((item) => {
        return {
          ...item,
          fundingDate: item.fundingDate ? new Date(item.fundingDate) : "",
          fundingCreatedDate: item.fundingCreatedDate ? new Date(item.fundingCreatedDate) : "",
        };
      });
      setInvestments(data);
    }
  };
  // delete a funding
  const handleDeleteInvestment = async (investmentId) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteInvestment(investmentId);
          dispatch(actionSuccess("Investment deleted successfully"));
          await handleFetchInvestments();
        },
        okText: "Delete",
        cancelText: "Cancel",
        content: "Are you sure you want to Delete Investment?",
        title: "dialogAlertCssWarning",
      })
    );
  };

  const getCompanyVideos = async () => {
    const response = await fetchVideo(companyId).catch((err) => {
      dispatch(actionError(err?.data?.message || "Something went wrong"));
    });
    setVideoList(response.data?.data?.companyVideos || []);
  };

  const handleDeleteVideo = async (id) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteVideo(companyId, id).catch((err) => {
            dispatch(actionError(err?.data?.message || "Something went wrong"));
          });
          dispatch(actionSuccess("Video deleted successfully"));
          getCompanyVideos();
        },
        okText: "Delete",
        cancelText: "Cancel",
        content: "Are you sure you want to Delete Video?",
        title: "dialogAlertCssWarning",
      })
    );
  };

  const getDocuments = () => {
    fetchCompanyDocumentsByCompanyId(companyId)
      .then((res) => {
        const docData = res.data?.data?.companyDocuments || [];
        setDocumentListing(docData);
      })
      .catch((err) => {
        dispatch(actionError(err.data?.message || "Something went wrong"));
      });
  };

  const deleteSingleDocument = async (data) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteCompanyDocument(data.companyId, data.Id)
            .then((res) => {
              if (res.status === 200) {
                dispatch(actionSuccess("Document deleted Successfully"));
              }
              getDocuments();
            })
            .catch((err) => {
              dispatch(actionError(err?.data?.message || "Something went wrong"));
            });
        },
        okText: "Delete",
        cancelText: "Cancel",
        content: "Are you sure you want to Delete Document?",
        title: "dialogAlertCssWarning",
      })
    );
  };

  useEffect(() => {
    if (companyId != "") {
      fetchOverviewData();
      handleFetchAddress();
      handleFetchFunding();
      handleFetchRevenue();
      handleFetchInvestments();
      getCompanyVideos();
      getDocuments();
    }
  }, [companyId]);

  // UseEffect for redux
  useEffect(() => {
    dispatch(setBasicDetailsCompany(companyInformation));
  }, [companyInformation]);

  return (
    <div className="gennx-content-wrapper padding-bottom-100i pt-3">
      <div className="mt-0 mx-3">
        <div className="h-full flex flex-col w-auto border border-[#DBDBDD] overflow-y-auto company-product-overview">
          <Accordion
            sx={{
              backgroundColor: "white",
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
              borderBottom: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0 !important",
              boxShadow: "none",
              "&.Mui-expanded": {
                margin: "0 !important",
                borderTop: "1px solid #e0e0e0",
              },
              "&:before": {
                display: "none",
              },
            }}
            expanded={expandedAccordions["overview"]}
            onChange={() => handleAccordionChange("overview")}
          >
            <AccordionSummary
              className="w-full"
              sx={{
                "> div": {
                  display: "flex",
                  justifyContent: "space-between",
                  width: " -webkit-fill-available",
                },
                height: "60px",
                padding: "15px !important",
              }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Box style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                <Box style={{ width: "100%", display: "flex", alignItems: "center" }}>
                  <Box style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box style={{ display: "flex", alignItems: "center" }}>
                      <CheckCircleIcon
                        sx={{
                          color: companyInformation.companyName === "" ? "action.disabled" : "#0CB963 !important",
                          fontSize: "32px !important",
                        }}
                      />
                      <Typography variant="h3" fontWeight="700" fontSize="16px" style={{ paddingLeft: "8px" }}>
                        Overview
                      </Typography>
                    </Box>
                    <Box style={{ display: "flex", alignItems: "center" }}>
                      {companyInformation.companyName === "" ? (
                        <Button
                          variant="text"
                          sx={{
                            fontSize: "16px",
                            color: "#F94F5E !important",
                            backgroundColor: "#FFF",
                            "&:disabled": {
                              opacity: "0.5 !important ",
                              backgroundColor: "#DBDBDD",
                              color: "#FFFFFF",
                            },
                            textTransform: "inherit !important",
                            "&:hover": {
                              backgroundColor: "#FFF", // Same as normal background to prevent hover effect
                            },
                          }}
                          onClick={() => {
                            setTimeout(() => {
                              history.push("/company/overview/add");
                            }, 10);
                          }}
                        >
                          <AddIcon className="!h-[18px] !w-[18px] mr-[10px]" /> Add New
                        </Button>
                      ) : (
                        <>
                          <Button
                            variant="text"
                            sx={{
                              color: "#F94F5E !important",
                              backgroundColor: "#FFF",
                              fontSize: "16px",
                              "&:disabled": {
                                opacity: "0.5 !important ",
                                backgroundColor: "#DBDBDD",
                                color: "#FFFFFF",
                              },
                              textTransform: "inherit !important",
                              "&:hover": {
                                backgroundColor: "#FFF", // Same as normal background to prevent hover effect
                              },
                            }}
                            onClick={() => {
                              setTimeout(() => {
                                history.push(`${split_url.join("/")}/overview/edit`, {
                                  companyId: companyId,
                                });
                              }, 10);
                            }}
                          >
                            <ModeEditOutlineOutlinedIcon style={{ color: "#f94f5e" }} className="!h-[18px] mr-2" /> Edit Details
                          </Button>
                          <Button variant="text" className="" onClick={() => handleAccordionChange("overview")}>
                            {expandedAccordions["overview"] ? (
                              <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                            ) : (
                              <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                            )}
                          </Button>
                        </>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            {expandedAccordions["overview"] && (
              <Box sx={{ width: "100%", display: "flex", alignItems: "center", paddingBottom: "20px" }}>
                <Box sx={{ width: "80%", display: "flex", alignItems: "flex-start" }}>
                  <Box sx={{ width: "20%", display: "flex", flexDirection: "column", mx: 2 }}>
                    <Typography variant="body1" sx={{ fontSize: "0.875rem" /* 14px */, color: "gray" }}>
                      Company Name
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.875rem",
                        overflow: expandedAccordions["overview"] ? "visible" : "hidden",
                        whiteSpace: expandedAccordions["overview"] ? "normal" : "nowrap",
                        wordBreak: expandedAccordions["overview"] ? "break-word" : "normal",
                        textOverflow: expandedAccordions["overview"] ? "unset" : "ellipsis",
                        color: "black",
                      }}
                    >
                      {companyInformation.companyName}
                    </Typography>
                  </Box>

                  <Box sx={{ width: "20%", display: "flex", flexDirection: "column", mx: 2 }}>
                    <Typography variant="body1" sx={{ color: "gray", fontSize: "0.875rem" }}>
                      Company Founded Year
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.875rem",
                        overflow: expandedAccordions["overview"] ? "visible" : "hidden",
                        whiteSpace: expandedAccordions["overview"] ? "normal" : "nowrap",
                        wordBreak: expandedAccordions["overview"] ? "break-word" : "normal",
                        textOverflow: expandedAccordions["overview"] ? "unset" : "ellipsis",
                        color: "black",
                      }}
                    >
                      {companyInformation.companyFoundedYear}
                    </Typography>
                  </Box>

                  <Box sx={{ width: "20%", display: "flex", flexDirection: "column", mx: 2 }}>
                    <Typography variant="body1" sx={{ color: "gray", fontSize: "0.875rem" }}>
                      Company Emp Size
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.875rem",
                        overflow: expandedAccordions["overview"] ? "visible" : "hidden",
                        whiteSpace: expandedAccordions["overview"] ? "normal" : "nowrap",
                        wordBreak: expandedAccordions["overview"] ? "break-word" : "normal",
                        textOverflow: expandedAccordions["overview"] ? "unset" : "ellipsis",
                        color: "black",
                      }}
                    >
                      {companyInformation.companyEmpSize}
                    </Typography>
                  </Box>

                  <Box sx={{ width: "20%", display: "flex", flexDirection: "column", mx: 2 }}>
                    <Typography variant="body1" sx={{ color: "gray", fontSize: "0.875rem" }}>
                      Company Website
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.875rem",
                        overflow: expandedAccordions["overview"] ? "visible" : "hidden",
                        whiteSpace: expandedAccordions["overview"] ? "normal" : "nowrap",
                        wordBreak: expandedAccordions["overview"] ? "break-word" : "normal",
                        textOverflow: expandedAccordions["overview"] ? "unset" : "ellipsis",
                        color: "black",
                      }}
                    >
                      {companyInformation.companyWebsite}
                    </Typography>
                  </Box>

                  <Box sx={{ width: "20%", display: "flex", flexDirection: "column", mx: 2 }}>
                    <Typography variant="body1" sx={{ color: "gray", fontSize: "0.875rem" }}>
                      Company Published Date
                    </Typography>
                    <Typography variant="body1" sx={{ fontSize: "0.875rem", color: "black" }}>
                      {companyInformation?.companyPublishedDate ? dayjs(companyInformation?.companyPublishedDate).format("DD-MMM-YYYY") : ""}
                    </Typography>
                  </Box>

                  <Box sx={{ width: "20%", display: "flex", flexDirection: "column", mx: 2 }}>
                    <Typography variant="body1" sx={{ color: "gray", fontSize: "0.875rem" }}>
                      Company Logo
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.875rem",
                        overflow: expandedAccordions["overview"] ? "visible" : "hidden",
                        whiteSpace: expandedAccordions["overview"] ? "normal" : "nowrap",
                        wordBreak: expandedAccordions["overview"] ? "break-word" : "normal",
                        textOverflow: expandedAccordions["overview"] ? "unset" : "ellipsis",
                        display: "flex",
                        color: "black",
                      }}
                    >
                      {companyInformation.companyName && (
                        <a
                          href={fetchCompanyLogoUrl(companyId, companyInformation.companyLogo)}
                          download={`${companyInformation.companyName}.png`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <i className="fas fa-download" data-tip="Download" /> {companyInformation.companyName}.png
                        </a>
                      )}
                      <ReactTooltip />
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
          </Accordion>
          <Accordion
            sx={{
              backgroundColor: "white",
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
              borderBottom: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0 !important",
              boxShadow: "none",
              "&.Mui-expanded": {
                margin: "0 !important",
                borderTop: "1px solid #e0e0e0",
              },
              "&:before": {
                display: "none",
              },
            }}
            className="!m-0"
            expanded={expandedAccordions["address"]}
            onChange={() => handleAccordionChange("address")}
            disabled={!Boolean(companyId)}
          >
            <AccordionSummary
              className="w-full"
              sx={{
                flexDirection: "row-reverse",
                "&.Mui-expanded": {
                  margin: "0",
                  minHeight: "48px",
                },
                "& .MuiAccordionSummary-content": {
                  flexGrow: 1,
                  margin: 0,
                  alignItems: "center",
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  marginLeft: "auto",
                },
                height: "60px",
                padding: "15px !important",
              }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Box className="w-full flex flex-col">
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    {false ? (
                      <ErrorIcon color="warning" />
                    ) : (
                      <CheckCircleIcon
                        sx={{
                          color: locations.companyLocation?.length > 0 ? "#0CB963 !important" : "action.disabled",
                          fontSize: "32px !important",
                        }}
                      />
                    )}
                    <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                      Address
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/address/add`, {
                            companyId: companyId,
                          });
                        }, 10);
                      }}
                    >
                      <AddIcon className="!h-[18px] !w-[18px] mr-[10px]" /> Add New
                    </Button>
                    {locations.companyLocation?.length > 0 && (
                      <Button variant="text" className="" onClick={() => handleAccordionChange("address")}>
                        {expandedAccordions["address"] ? (
                          <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        ) : (
                          <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            {expandedAccordions["address"] && (
              <AccordionDetails
                sx={{
                  "& .form-group": {
                    marginBottom: "0 !important",
                  },
                }}
              >
                <Box>
                  <table className="normal-table cy-tbl-address table table-bordered no-vertical-borders">
                    <thead className="internal-grid">
                      <tr>
                        <th>Address</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>City</th>
                        <th>Zip</th>
                        <th className="text-center internal-grid-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {locations.companyLocation &&
                        locations.companyLocation.length > 0 &&
                        locations.companyLocation.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td className="overflow">{item.address1}</td>
                              <td>{item.countryName || "--"}</td>
                              <td>{item.stateName || "--"}</td>
                              <td>{item.cityName || "--"}</td>
                              <td>{item.postCode || "--"}</td>
                              <td className="text-center">
                                <ThreeDotMenu
                                  rowID={item.id}
                                  Edit={() => {
                                    history.push(`${split_url.join("/")}/address/${item.id}/edit`, {
                                      companyId: companyId,
                                      addressId: item.id,
                                    });
                                  }}
                                  Delete={() => {
                                    handleDeleteAddress(item.id);
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </Box>
              </AccordionDetails>
            )}
          </Accordion>
          <Accordion
            sx={{
              backgroundColor: "white",
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
              borderBottom: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0 !important",
              boxShadow: "none",
              "&.Mui-expanded": {
                margin: "0 !important",
                borderTop: "1px solid #e0e0e0",
              },
              "&:before": {
                display: "none",
              },
            }}
            className="!m-0"
            expanded={expandedAccordions["fundings"]}
            onChange={() => handleAccordionChange("fundings")}
            disabled={!Boolean(companyId)}
          >
            <AccordionSummary
              className="w-full"
              sx={{
                flexDirection: "row-reverse",
                "&.Mui-expanded": {
                  margin: "0",
                  minHeight: "48px",
                },
                "& .MuiAccordionSummary-content": {
                  flexGrow: 1,
                  margin: 0,
                  alignItems: "center",
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  marginLeft: "auto",
                },
                height: "60px",
                padding: "15px !important",
              }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Box className="w-full flex flex-col">
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    {false ? (
                      <ErrorIcon color="warning" />
                    ) : (
                      <CheckCircleIcon
                        sx={{
                          color: fundings?.length > 0 ? "#0CB963 !important" : "action.disabled",
                          fontSize: "32px !important",
                        }}
                      />
                    )}
                    <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                      Funding
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/funding/add`, {
                            companyId: companyId,
                          });
                        }, 10);
                      }}
                    >
                      <AddIcon className="!h-[18px] !w-[18px] mr-[10px]" /> Add New
                    </Button>
                    {fundings?.length > 0 && (
                      <Button variant="text" className="" onClick={() => handleAccordionChange("fundings")}>
                        {expandedAccordions["fundings"] ? (
                          <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        ) : (
                          <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            {expandedAccordions["fundings"] && (
              <AccordionDetails
                sx={{
                  "& .form-group": {
                    marginBottom: "0 !important",
                  },
                }}
              >
                <Box>
                  <table className="normal-table cy-tbl-address table table-bordered no-vertical-borders">
                    <thead>
                      <tr>
                        <th>Transaction Name</th>
                        <th className="text-left">Date</th>
                        <th className="text-left" style={{ width: window.innerWidth < 1400 ? "20%" : "200px" }}>
                          Amount (Million USD)
                        </th>
                        <th>Funding Type</th>
                        <th>Investors</th>
                        <th className="text-center internal-grid-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fundings.length
                        ? fundings.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td>{item.fundingName || "--"}</td>
                                <td className="text-left">{item.fundingDate ? moment(item.fundingDate).format("DD MMM yyyy") : "--"}</td>
                                <td align="text-left">{(item.fundingAmount > 0 && `$${item.fundingAmount}`) || "--"}</td>
                                <td>{item.fundingTypeRound || "--"}</td>
                                {/* <td align="right"></td> */}
                                <td className="overflow">{item.fundingInvestors.map((investor) => investor.companyName).join(", ") || "--"}</td>
                                <td className="text-center">
                                  <ThreeDotMenu
                                    rowID={item.id}
                                    Edit={() => {
                                      history.push(`${split_url.join("/")}/funding/${item.id}/edit`, {
                                        companyId: companyId,
                                        fundingId: item.id,
                                      });
                                    }}
                                    Delete={() => {
                                      handleDeleteFunding(item.id);
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                </Box>
              </AccordionDetails>
            )}
          </Accordion>
          <Accordion
            sx={{
              backgroundColor: "white",
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
              borderBottom: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0 !important",
              boxShadow: "none",
              "&.Mui-expanded": {
                margin: "0 !important",
                borderTop: "1px solid #e0e0e0",
              },
              "&:before": {
                display: "none",
              },
            }}
            className="!m-0"
            expanded={expandedAccordions["revenue"]}
            onChange={() => handleAccordionChange("revenue")}
            disabled={!Boolean(companyId)}
          >
            <AccordionSummary
              className="w-full"
              sx={{
                flexDirection: "row-reverse",
                "&.Mui-expanded": {
                  margin: "0",
                  minHeight: "48px",
                },
                "& .MuiAccordionSummary-content": {
                  flexGrow: 1,
                  margin: 0,
                  alignItems: "center",
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  marginLeft: "auto",
                },
                height: "60px",
                padding: "15px !important",
              }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Box className="w-full flex flex-col">
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    {false ? (
                      <ErrorIcon color="warning" />
                    ) : (
                      <CheckCircleIcon
                        sx={{
                          color: revenue?.length > 0 ? "#0CB963 !important" : "action.disabled",
                          fontSize: "32px !important",
                        }}
                      />
                    )}
                    <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                      Revenue
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/revenue/add`, {
                            companyId: companyId,
                          });
                        }, 10);
                      }}
                    >
                      <AddIcon className="!h-[18px] !w-[18px] mr-[10px]" /> Add New
                    </Button>
                    {revenue?.length > 0 && (
                      <Button variant="text" className="" onClick={() => handleAccordionChange("revenue")}>
                        {expandedAccordions["revenue"] ? (
                          <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        ) : (
                          <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            {expandedAccordions["revenue"] && (
              <AccordionDetails
                sx={{
                  "& .form-group": {
                    marginBottom: "0 !important",
                  },
                }}
              >
                <Box>
                  <table className="normal-table cy-tbl-address table table-bordered no-vertical-borders">
                    <thead className="internal-grid">
                      <tr>
                        <th className="text-left" style={{ width: window.innerWidth < 1400 ? "20%" : "200px" }}>
                          Revenue Year
                        </th>
                        <th className="text-left" style={{ width: window.innerWidth < 1400 ? "20%" : "200px" }}>
                          Amount (Million USD)
                        </th>
                        <th>Revenue Source URL</th>
                        <th className="text-center internal-grid-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {revenue.length
                        ? revenue.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td className="text-left">{item.revenueYear || "--"}</td>
                                <td className="text-left">{(typeof item.revenueAmount === "number" && `$${item.revenueAmount}`) || "--"}</td>
                                <td>{item.revenueSourceUrl}</td>
                                <td className="text-center">
                                  <ThreeDotMenu
                                    rowID={item.id}
                                    Edit={() => {
                                      history.push(`${split_url.join("/")}/revenue/${item.id}/edit`, {
                                        companyId: companyId,
                                        revenueId: item.id,
                                      });
                                    }}
                                    Delete={() => {
                                      handleDeleteRevenue(item.id);
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                </Box>
              </AccordionDetails>
            )}
          </Accordion>
          <Accordion
            sx={{
              backgroundColor: "white",
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
              borderBottom: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0 !important",
              boxShadow: "none",
              "&.Mui-expanded": {
                margin: "0 !important",
                borderTop: "1px solid #e0e0e0",
              },
              "&:before": {
                display: "none",
              },
            }}
            className="!m-0"
            expanded={expandedAccordions["investments"]}
            onChange={() => handleAccordionChange("investments")}
            disabled={!Boolean(companyId)}
          >
            <AccordionSummary
              className="w-full"
              sx={{
                flexDirection: "row-reverse",
                "&.Mui-expanded": {
                  margin: "0",
                  minHeight: "48px",
                },
                "& .MuiAccordionSummary-content": {
                  flexGrow: 1,
                  margin: 0,
                  alignItems: "center",
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  marginLeft: "auto",
                },
                height: "60px",
                padding: "15px !important",
              }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Box className="w-full flex flex-col">
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    {false ? (
                      <ErrorIcon color="warning" />
                    ) : (
                      <CheckCircleIcon
                        sx={{
                          color: investments?.length > 0 ? "#0CB963 !important" : "action.disabled",
                          fontSize: "32px !important",
                        }}
                      />
                    )}
                    <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                      Investments
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/investment/add`, {
                            companyId: companyId,
                          });
                        }, 10);
                      }}
                    >
                      <AddIcon className="!h-[18px] !w-[18px] mr-[10px]" /> Add New
                    </Button>
                    {investments?.length > 0 && (
                      <Button variant="text" className="" onClick={() => handleAccordionChange("investments")}>
                        {expandedAccordions["investments"] ? (
                          <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        ) : (
                          <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            {expandedAccordions["investments"] && (
              <AccordionDetails
                sx={{
                  "& .form-group": {
                    marginBottom: "0 !important",
                  },
                }}
              >
                <Box>
                  <table className="normal-table table table-bordered no-vertical-borders">
                    <thead className="internal-grid">
                      <tr>
                        <th>Transaction Name</th>
                        <th className="text-left">Date</th>
                        <th className="text-left" style={{ width: window.innerWidth < 1400 ? "20%" : "200px" }}>
                          Amount (Million USD)
                        </th>
                        <th>Funding Type</th>
                        <th>Company</th>
                        <th className="text-center internal-grid-action"> Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {investments.length
                        ? investments.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td>{item.fundingName || "--"}</td>
                                <td className="text-left">{item.fundingDate ? moment(item.fundingDate).format("DD MMM yyyy") : "--"}</td>
                                <td className="text-left">{item.fundingAmount || "--"}</td>
                                <td>{item.fundingTypeRound || "--"}</td>
                                <td>{item.fundingOnCompanyId.map((fundingcCompany) => fundingcCompany.companyName).toString() || "--"}</td>
                                <td className="text-center">
                                  <ThreeDotMenu
                                    rowID={item.id}
                                    Edit={() => {
                                      history.push(`${split_url.join("/")}/investment/${item.id}/edit`, {
                                        companyId: companyId,
                                        investmentId: item.id,
                                      });
                                    }}
                                    Delete={() => {
                                      handleDeleteInvestment(item.id);
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                </Box>
              </AccordionDetails>
            )}
          </Accordion>
          <Accordion
            sx={{
              backgroundColor: "white",
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
              borderBottom: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0 !important",
              boxShadow: "none",
              "&.Mui-expanded": {
                margin: "0 !important",
                borderTop: "1px solid #e0e0e0",
              },
              "&:before": {
                display: "none",
              },
            }}
            className="!m-0"
            expanded={expandedAccordions["videos"]}
            onChange={() => handleAccordionChange("videos")}
            disabled={!Boolean(companyId)}
          >
            <AccordionSummary
              className="w-full"
              sx={{
                flexDirection: "row-reverse",
                "&.Mui-expanded": {
                  margin: "0",
                  minHeight: "48px",
                },
                "& .MuiAccordionSummary-content": {
                  flexGrow: 1,
                  margin: 0,
                  alignItems: "center",
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  marginLeft: "auto",
                },
                height: "60px",
                padding: "15px !important",
              }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Box className="w-full flex flex-col">
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    {false ? (
                      <ErrorIcon color="warning" />
                    ) : (
                      <CheckCircleIcon
                        sx={{
                          color: videoList?.length > 0 ? "#0CB963 !important" : "action.disabled",
                          fontSize: "32px !important",
                        }}
                      />
                    )}
                    <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                      Videos
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/video/add`, {
                            companyId: companyId,
                          });
                        }, 10);
                      }}
                    >
                      <AddIcon className="!h-[18px] !w-[18px] mr-[10px]" /> Add New
                    </Button>
                    {videoList?.length > 0 && (
                      <Button variant="text" className="" onClick={() => handleAccordionChange("videos")}>
                        {expandedAccordions["videos"] ? (
                          <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        ) : (
                          <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            {expandedAccordions["videos"] && (
              <AccordionDetails
                sx={{
                  "& .form-group": {
                    marginBottom: "0 !important",
                  },
                }}
              >
                <Box>
                  <table className="normal-table table table-bordered no-vertical-borders">
                    <thead className="internal-grid">
                      <tr>
                        <th>Title</th>
                        <th>Video Source</th>
                        <th>Link</th>
                        <th>Video ID</th>
                        <th>Duration(Minutes)</th>
                        <th className="text-center internal-grid-action"> Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {videoList.map((item, i) => {
                        return (
                          <React.Fragment key={`vid-${i}`}>
                            <tr>
                              <td>{item.videoTitle}</td>
                              <td>{item.videoSource}</td>
                              <td>{item.videoSource === "Vimeo" ? `https://vimeo.com` : `https://www.youtube.com`}</td>
                              <td>{item.videoId}</td>
                              <td>{item.videoDuration}</td>
                              <td className="text-center">
                                <ThreeDotMenu
                                  rowID={item.id}
                                  Edit={() => {
                                    history.push(`${split_url.join("/")}/video/${item.id}/edit`, {
                                      companyId: companyId,
                                      videoId: item.id,
                                    });
                                  }}
                                  Delete={() => {
                                    handleDeleteVideo(item.id);
                                  }}
                                />
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
              </AccordionDetails>
            )}
          </Accordion>
          <Accordion
            sx={{
              backgroundColor: "white",
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
              borderBottom: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0 !important",
              boxShadow: "none",
              "&.Mui-expanded": {
                margin: "0 !important",
                borderTop: "1px solid #e0e0e0",
              },
              "&:before": {
                display: "none",
              },
            }}
            className="!m-0"
            expanded={expandedAccordions["documents"]}
            onChange={() => handleAccordionChange("documents")}
            disabled={!Boolean(companyId)}
          >
            <AccordionSummary
              className="w-full"
              sx={{
                flexDirection: "row-reverse",
                "&.Mui-expanded": {
                  margin: "0",
                  minHeight: "48px",
                },
                "& .MuiAccordionSummary-content": {
                  flexGrow: 1,
                  margin: 0,
                  alignItems: "center",
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  marginLeft: "auto",
                },
                height: "60px",
                padding: "15px !important",
              }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Box className="w-full flex flex-col">
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    {false ? (
                      <ErrorIcon color="warning" />
                    ) : (
                      <CheckCircleIcon
                        sx={{
                          color: documentListing?.length > 0 ? "#0CB963 !important" : "action.disabled",
                          fontSize: "32px !important",
                        }}
                      />
                    )}
                    <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                      Documents
                    </Typography>
                    <span className="pl-2">(Maximum 10 files allowed)</span>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                        "&:disabled": {
                          opacity: "0.5 !important ",
                          backgroundColor: "#DBDBDD",
                          color: "#FFFFFF",
                          cursor: "default !important",
                        },
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/documents/add`, {
                            companyId: companyId,
                          });
                        }, 10);
                      }}
                      disabled={documentListing?.length === 10}
                    >
                      <AddIcon className="!h-[18px] !w-[18px] mr-[10px]" /> Add New
                    </Button>
                    {documentListing?.length > 0 && (
                      <Button variant="text" className="" onClick={() => handleAccordionChange("documents")}>
                        {expandedAccordions["documents"] ? (
                          <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        ) : (
                          <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px" }} />
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            {expandedAccordions["documents"] && (
              <AccordionDetails
                sx={{
                  "& .form-group": {
                    marginBottom: "0 !important",
                  },
                }}
              >
                <Box>
                  <table className="normal-table table table-bordered no-vertical-borders">
                    <thead className="internal-grid">
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Document</th>
                        <th className="text-center internal-grid-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {documentListing.map((item, i) => {
                        return (
                          <React.Fragment key={`doc-${i}`}>
                            <tr>
                              <td>{item.docTitle}</td>
                              <td>
                                {item.docDescription
                                  .replace(/(<([^>]+)>|&nbsp;)/gi, "")
                                  .substring(0, 40)
                                  .concat(".....")}
                              </td>
                              <td>
                                <a href={fetchCompanyDocumentUrl(item.docFileName, item.docName)} download>
                                  <i className="fas fa-download" data-tip="Download" /> {item.docName}
                                </a>
                                <ReactTooltip />
                              </td>
                              <td className="text-center internal-grid-action">
                                <ThreeDotMenu
                                  rowID={item.id}
                                  Edit={() => {
                                    history.push(`${split_url.join("/")}/documents/${item.id}/edit`, {
                                      companyId: companyId,
                                      documentId: item.id,
                                    });
                                  }}
                                  Delete={() => {
                                    deleteSingleDocument({ companyId: companyId, Id: item.id });
                                  }}
                                />
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
              </AccordionDetails>
            )}
          </Accordion>
        </div>
      </div>
      <div className={Boolean(companyId) ? "form-submit-box" : "form-submit-box d-none"}>
        <ActionButtons
          accessRights={props.accessRights}
          companyId={companyId}
          selectedIndex={props.selectedIndex}
          setCurrentTab={(selectedIndex) => {
            props.setCurrentTab(selectedIndex);
          }}
          hashArr={props.hashArr}
        />
      </div>
    </div>
  );
};

BasicUI.propTypes = {
  companyId: PropTypes.string, // Declare type here
};

export default BasicUI;
